import { Card, CardContent, Header } from "semantic-ui-react";
import { NewListPageComponent } from "../components/page/NewListPageComponent";
import {
  appendIdToMultipleFormComponentProps,
  getEventMetadata,
  getSession,
} from "../helper";
import { LIST_REFERENCE_LIBRARY_ELEMENTS } from "../routes/queries";
import { NewNewFormComponentProps } from "../components/new_form/NewNewFormComponent";
import {
  CREATE_REFERENCE_LIBRARY_ELEMENT,
  DELETE_REFERENCE_LIBRARY_ELEMENT,
  UPDATE_REFERENCE_LIBRARY,
} from "../routes/mutations";
import Markdown from "react-markdown";
import { CardDotMenuComponent } from "../components/new_card/dot_menu/CardDotMenuComponent";
import {
  getReferenceLibraryForm,
  getReferenceLibraryFormFields,
} from "./reference_library_form";

const ReferenceLibraryCard = (props: {
  data: any;
  setReloadKey: any;
  pageData: any;
  setPageData: any;
}) => {
  return (
    <Card fluid>
      <Card.Content>
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="card-header"
        >
          <Card.Header>
            <b>{props.data.name}</b>
          </Card.Header>
          <CardDotMenuComponent
            cardData={props.data}
            setReloadKey={props.setReloadKey}
            pageData={props.pageData}
            setPageData={props.setPageData}
            props={{
              menuItems: [
                {
                  type: "api_call",
                  label: "Delete",
                  apiCall: {
                    documentNode: DELETE_REFERENCE_LIBRARY_ELEMENT,
                    key: "deleteReferenceLibraryElement",
                  },
                  callback: (
                    data: any,
                    setReloadKey: any,
                    pageData: any,
                    setPageData: any,
                  ) => {
                    setReloadKey((prev: number) => prev + 1);
                  },
                  apiCallVariables: (data: any) => {
                    return {
                      id: props.data.id,
                      session: getSession(),
                      eventMetadata: getEventMetadata(),
                    };
                  },
                  showMenuOption: (data: any) => {
                    return true;
                  },
                },
                {
                  type: "new_form_modal",
                  apiCall: {
                    documentNode: UPDATE_REFERENCE_LIBRARY,
                    key: "updateReferenceLibrary",
                  },
                  label: "Edit",
                  modalHeader: "Edit Reference Library Element",
                  showMenuOption: (data: any) => {
                    return true;
                  },
                  formComponentProps: new NewNewFormComponentProps({
                    form: appendIdToMultipleFormComponentProps(
                      getReferenceLibraryForm(),
                      props.data,
                    ),
                    startingData: {
                      id: props.data.id,
                      name: props.data.name,
                      type: props.data.type,
                      body: props.data.body,
                      physicalLibraryLocationId:
                        props.data.physicalLibraryLocationId,
                    },
                  }),
                  callback: (data) => {
                    props.setReloadKey((k: number) => k + 1);
                  },
                },
              ],
            }}
          />
        </div>
      </Card.Content>
      <CardContent>
        {props.data.type === 1 && props.data.body && (
          <Markdown className="document-body-content">
            {props.data.body}
          </Markdown>
        )}
        {props.data.type === 2 && (
          <div className="link-content">
            <a target="_blank" href={props.data.body} rel="noreferrer">
              {props.data.body}
            </a>
          </div>
        )}
        {props.data.type === 3 && props.data.physicalLibraryLocation && (
          <div className="physical-location">
            {props.data.physicalLibraryLocation!.name}
          </div>
        )}
      </CardContent>
      <CardContent className="related-elements">
        <Header>Related Elements</Header>
        {props.data.elements.map((element: any) => (
          <div key={element.id}>{element.name}</div>
        ))}
      </CardContent>
    </Card>
  );
};

export const NewReferenceLibraryPage = () => {
  return (
    <NewListPageComponent
      props={{
        type: "list_page",
        query: {
          documentNode: LIST_REFERENCE_LIBRARY_ELEMENTS,
          key: "listReferenceLibraryElements",
        },
        queryVariables: {
          session: getSession(),
        },
        itemName: "Reference Library Element",
        card: ReferenceLibraryCard,
        creationProps: {
          formComponentProps: new NewNewFormComponentProps({
            form: {
              type: "multiple_form",
              formFields: getReferenceLibraryFormFields(),
              typeSelector: {
                type: "hardcoded_dropdown",
                key: "type",
                label: "Type",
                required: true,
                options: [
                  { key: 1, value: 1, text: "Document" },
                  { key: 2, value: 2, text: "Link" },
                  { key: 3, value: 3, text: "Physical Item" },
                ],
              },
            },
            startingData: {
              type: 1,
              name: undefined,
              elementIds: [],
            },
          }),
          apiCall: {
            documentNode: CREATE_REFERENCE_LIBRARY_ELEMENT,
            key: "createReferenceLibraryElement",
          },
        },
      }}
    />
  );
};
